import ScrollCarousel from '../../components/ScrollCarousel';

const SELECTORS = {
  viewport: '[data-article-carousel-viewport]',
  track: '[data-article-carousel-track]',
};

const carousels = [];

export default function () {
  document.querySelectorAll('[data-article-carousel]').forEach((el) => {
    if (el.getAttribute('initialized') === 'true') {
      return;
    }

    // The slides now live inside the scroll track, so count them there rather
    // than on the carousel element (which only holds the viewport wrapper).
    const track = el.querySelector(SELECTORS.track);
    if (!track || track.children.length === 0) {
      return;
    }

    el.setAttribute('initialized', 'true');

    // Matches Flickity's defaults: one cell per view, prev/next buttons and
    // page dots on, draggable, no wrap.
    const carousel = new ScrollCarousel(el, {
      selectors: SELECTORS,
      prevNextButtons: true,
      pageDots: true,
      draggable: true,
      slidesPerView: 1,
      ariaLabel: 'Article carousel',
    });

    carousels.push(carousel);
  });
}
